import {useListView} from '../../core/ListViewProvider'
import {PurchasedProductsListToolbar} from './PurchasedProductListToolbar'
import {PurchasedProductsListGrouping} from './PurchasedProductsListGrouping'
import {PurchasedProductsListSearchComponent} from './PurchasedProductsListSearchComponent'

const PurchasedProductsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <PurchasedProductsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <PurchasedProductsListGrouping /> : <PurchasedProductsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {PurchasedProductsListHeader}
